import React from 'react';

//

const ErrorHandler = (err, src, callback) => {
    console.log("Error encountered in the following module: " + src);
    console.log(err);
    if(!!err.code && err.code == 401) callback({ type: 'SET_UNAUTHORIZED', payload: {} });
}
export default ErrorHandler;